import React from "react";
import AdminPageForm from "../components/AdminPageForm";

function AdminPage() {
  return (
    <>
      <h1>Hello Admin</h1>
      <h4>Welcome</h4>
      <AdminPageForm />
    </>
  );
}

export default AdminPage;
